import React, { Fragment, Component } from 'react';
import './ThumbsComponent.css';

class Thumbs extends Component {

    constructor(props) {
       super(props);
    }

    handleThumbsUp = () => {
        this.props.sendMessage("👍");
    }

    handleThumbsDown = () => {
        this.props.sendMessage("👎");
    }

    render() {
        return (
            <Fragment>
                <div className="thumbs">
                    <button onClick={this.handleThumbsUp} className="up"></button>
                    <button onClick={this.handleThumbsDown} className="down"></button>
                </div>
            </Fragment>
        )
    }

}

export default Thumbs;